import React from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { actionRoute } from '../redux/actions';
// import { selectRouteSimple } from '../redux/selectors';
// import { routeDataGet } from '../utils/routes-helper';


// TODO
const UniBreadcrumbs = (props) => {
  // const dispatch = useDispatch();
  // const routeSimple = useSelector(selectRouteSimple);
  // let route = routeSimple.route;
  // let breadcrumbs = routeSimple.breadcrumbs;
  const breadcrumbs = props.breadcrumbs;

  let clicked = (what) => {
    /*
    return () => {
      dispatch(actionRoute(what))
    };
    */
  }

  let jsxBreadcrumbs = [];
  /*
  // push home segment
  jsxBreadcrumbs.push(
    <span key={'key0HOME'} className="breadcrumbs-item clickable" onClick={clicked('HOME')}><i className="fa fa-home"></i> Početna</span>
  );
  // push other segment
  */
  breadcrumbs.forEach((item, index) => {
    if (item !== 'HOME') {
      if (index > 0) { // add breadcrumbs delimiter
        jsxBreadcrumbs.push(
          <span key={index + 'a'} className="unicompo-breadcrumbs__delimiter">&gt;</span>
        );
      }
      let handleClick = () => { };
      if (typeof item.handleClick === 'function') {
        handleClick = item.handleClick;
      }
      let href = null;
      if (typeof item.href === 'string') {
        href = item.href;
        jsxBreadcrumbs.push(
          <a key={index + 'b'} href={href} className="unicompo-breadcrumbs__item clickable" onClick={handleClick}>{item?.title}</a>
        );
      } else {
        jsxBreadcrumbs.push(
          <span key={index + 'b'} className="unicompo-breadcrumbs__item clickable" onClick={handleClick}>{item?.title}</span>
        );
      }
    }
  });

  return (
    <>
      <div className="unicompo-breadcrumbs">
        {jsxBreadcrumbs}
      </div>
    </>
  );
};

export default UniBreadcrumbs;

/*
  return (
    <>
      <div className="breadcrumbs"><span className="breadcrumbs-item clickable" onClick={clicked('HOME')}><i className="fa fa-home"></i> Početna</span><span className="breadcrumbs-delimiter">&gt;</span><span className="breadcrumbs-item">Strana 1</span></div>
    </>
  );
*/
